import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "ais-RefinementList-list" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id", "value", "checked", "onChange"]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["disabled", "onClick"]
const _hoisted_9 = { class: "ais-HierarchicalMenu-list" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["id", "href", "onClick"]
const _hoisted_12 = { class: "newsletter-level-1" }
const _hoisted_13 = {
  key: 0,
  class: "ais-HierarchicalMenu-list-sub ml-xs-3"
}
const _hoisted_14 = ["id"]
const _hoisted_15 = ["id", "value", "checked", "onChange"]
const _hoisted_16 = ["id"]
const _hoisted_17 = ["id"]
const _hoisted_18 = ["id"]
const _hoisted_19 = ["id", "value", "checked", "onChange"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "slider" }, null, -1)
const _hoisted_21 = ["id"]


const __default__ = {
  name: 'SearchFilters',
}

import AppAccordionPanel from '../global/accordion/AppAccordionPanel.vue'
import { AisRefinementList, AisToggleRefinement, AisHierarchicalMenu } from 'vue-instantsearch/vue3/es'

// Define props using Composition API

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  code: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'ais-refinement-list',
    required: true,
  },
},
  setup(__props) {

const props = __props



// Methods can be added directly in the <script setup> block if needed
const isActive = (attribute: string): string => {
  return attribute === 'type' ? 'active' : ''
}

// Method to process the title by replacing underscores with spaces
const removeUnderscores = (textValue: string): string => {
  return textValue.replace(/_/g, ' ')
}

const addUnderscores = (textValue: string): string => {
  return textValue.replace(/ /g, '_')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.type != 'ais-toggle-refinement')
      ? (_openBlock(), _createBlock(AppAccordionPanel, {
          key: 0,
          class: "active"
        }, {
          title: _withCtx(() => [
            _createElementVNode("span", {
              id: `filter-title-${__props.title}`,
              class: "filter-title"
            }, _toDisplayString(__props.title), 9, _hoisted_1)
          ]),
          content: _withCtx(() => [
            (__props.type == 'ais-refinement-list')
              ? (_openBlock(), _createBlock(_unref(AisRefinementList), {
                  key: 0,
                  attribute: __props.code,
                  limit: 10,
                  "sort-by": ['isRefined', 'name:asc']
                }, {
                  default: _withCtx(({ items, isShowingMore, canToggleShowMore, refine, toggleShowMore }) => [
                    _createElementVNode("ul", _hoisted_2, [
                      (!items.length)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_3, " No results. "))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.value,
                          class: _normalizeClass(`ais-RefinementList-item${item.isRefined ? '--selected' : ''} pt-xs-1 pb-xs-1`)
                        }, [
                          _createElementVNode("label", {
                            id: `refinement-list-item-${item.label}`,
                            class: "ais-RefinementList-label"
                          }, [
                            _createElementVNode("input", {
                              id: `RefinementList-checkbox-${item.label}`,
                              class: "ais-RefinementList-checkbox",
                              type: "checkbox",
                              value: item.value,
                              checked: item.isRefined,
                              onChange: ($event: any) => (refine(item.value))
                            }, null, 40, _hoisted_5),
                            _createElementVNode("span", {
                              id: `RefinementList-labelText-${item.label}`,
                              class: "ais-RefinementList-labelText"
                            }, _toDisplayString(removeUnderscores(item.label)), 9, _hoisted_6),
                            _createElementVNode("span", {
                              id: `RefinementList-count-${item.label}`,
                              class: "ais-RefinementList-count"
                            }, " (" + _toDisplayString(item.count) + ")", 9, _hoisted_7)
                          ], 8, _hoisted_4)
                        ], 2))
                      }), 128))
                    ]),
                    (!!canToggleShowMore)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn primary alt small ais-RefinementList-showMore",
                          disabled: !canToggleShowMore,
                          onClick: toggleShowMore
                        }, _toDisplayString(!isShowingMore ? 'Show more' : 'Show less'), 9, _hoisted_8))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["attribute"]))
              : _createCommentVNode("", true),
            (__props.type == 'ais-hierarchical-menu')
              ? (_openBlock(), _createBlock(_unref(AisHierarchicalMenu), {
                  key: 1,
                  attributes: ['newsletter_level_one', 'newsletter_level_two']
                }, {
                  default: _withCtx(({ items, refine, createURL }) => [
                    _createElementVNode("ul", _hoisted_9, [
                      (!items.length)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_10, " No results. "))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.label,
                          class: _normalizeClass({'ais-HierarchicalMenu-item--selected': item.isRefined})
                        }, [
                          _createElementVNode("a", {
                            id: `ais-HierarchicalMenu-link-${addUnderscores(item.label)}`,
                            href: createURL(item.value),
                            class: "ais-HierarchicalMenu-link p-xs-2",
                            onClick: _withModifiers(($event: any) => (refine(item.value)), ["prevent"])
                          }, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(item.label) + " (" + _toDisplayString(item.count) + ")", 1)
                          ], 8, _hoisted_11),
                          (item.data && item.data.length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (child) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: child.label,
                                    class: _normalizeClass(['pb-xs-1','pt-xs-1',{'ais-HierarchicalMenu-item--selected': child.isRefined}])
                                  }, [
                                    _createElementVNode("label", {
                                      id: `HierarchicalMenu-label-${addUnderscores(child.label)}`,
                                      class: "ais-HierarchicalMenu-label"
                                    }, [
                                      _createElementVNode("input", {
                                        id: `RefinementList-radio-${addUnderscores(child.label)}`,
                                        class: "ais-RefinementList-radio mr-xs-1",
                                        type: "radio",
                                        value: child.value,
                                        checked: child.isRefined,
                                        onChange: ($event: any) => (refine(child.value))
                                      }, null, 40, _hoisted_15),
                                      _createElementVNode("span", {
                                        id: `HierarchicalMenu-labelText-${addUnderscores(child.label)}`,
                                        class: "ais-HierarchicalMenu-labelText"
                                      }, _toDisplayString(child.label), 9, _hoisted_16),
                                      _createElementVNode("span", {
                                        id: `HierarchicalMenu-count-${addUnderscores(child.label)}`,
                                        class: "ais-HierarchicalMenu-count"
                                      }, " (" + _toDisplayString(child.count) + ")", 9, _hoisted_17)
                                    ], 8, _hoisted_14)
                                  ], 2))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.type == 'ais-toggle-refinement')
      ? (_openBlock(), _createBlock(_unref(AisToggleRefinement), {
          key: 1,
          attribute: __props.code,
          on: "true",
          label: __props.title,
          class: "accordion panel pb-xs-2 pt-xs-2 pl-xs-2"
        }, {
          default: _withCtx(({ value, refine }) => [
            _createElementVNode("label", {
              id: `ToggleRefinement-label-${addUnderscores(__props.title)}`,
              class: "ais-ToggleRefinement-label"
            }, [
              _createElementVNode("input", {
                id: `ToggleRefinement-checkbox-${addUnderscores(__props.title)}`,
                class: "ais-ToggleRefinement-checkbox mr-xs-1",
                type: "checkbox",
                value: value,
                checked: value.isRefined,
                onChange: ($event: any) => (refine(value))
              }, null, 40, _hoisted_19),
              _hoisted_20,
              _createElementVNode("span", {
                id: `ToggleRefinement-labelText-${addUnderscores(__props.title)}`,
                class: "ais-ToggleRefinement-labelText"
              }, _toDisplayString(__props.title), 9, _hoisted_21)
            ], 8, _hoisted_18)
          ]),
          _: 1
        }, 8, ["attribute", "label"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})